class ybSelectController {
    constructor($timeout,$sce) {
        "ngInject";
        this.$timeout=$timeout;
    }
    selectItem(item){
        this.selected=item;
        this.$timeout(()=>{
            this.change();
        })
    }
}

export default ybSelectController;



// WEBPACK FOOTER //
// ./src/app/common/yb-select/yb-select.controller.js